module.exports = __webpack_public_path__ + "static/media/kakaotalk-banner.6b4ed862.png";